import { render } from "./TicketDetail.vue?vue&type=template&id=af3e414c&scoped=true&ts=true"
import script from "./TicketDetail.vue?vue&type=script&lang=ts"
export * from "./TicketDetail.vue?vue&type=script&lang=ts"

import "./TicketDetail.vue?vue&type=style&index=0&id=af3e414c&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3e414c"]])

export default __exports__